import {
  Image,
  PromoModalAction,
  PromoModalActions,
  PromoModalBody,
  PromoModalCloseButton,
  PromoModalContent,
  PromoModalDescription,
  PromoModalFooter,
  PromoModalMedia,
  PromoModalRoot,
  PromoModalTitle,
} from '@cian/ui-kit';
import { IconActionClose12, IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { NBSP } from 'shared/constants';

import topImage from './assets/top-image.png';

interface INewbuildingBrokerOnboardingProps {
  onClose: VoidFunction;
}

export const NewbuildingBrokerOnboarding: React.FC<INewbuildingBrokerOnboardingProps> = ({ onClose }) => {
  const handleOpenChange = React.useCallback(
    (nextOpen: boolean) => {
      // istanbul ignore else
      if (!nextOpen) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <PromoModalRoot open={true} onOpenChange={handleOpenChange}>
      <PromoModalContent>
        <PromoModalMedia>
          <PromoModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose12 />} />
          <Image src={topImage} width="100%" height="100%" objectFit="cover" alt="" borderRadius="0" />
        </PromoModalMedia>
        <PromoModalBody>
          <PromoModalTitle>Квартиру в{NBSP}новостройке можно забронировать</PromoModalTitle>
          <PromoModalDescription>
            Нашли ту{NBSP}самую — жмите на{NBSP}кнопку
          </PromoModalDescription>
        </PromoModalBody>
        <PromoModalFooter>
          <PromoModalActions>
            <PromoModalAction
              fullWidth
              onClick={onClose}
              afterIcon={<IconProductHighDemand16 color="icon-inverted-default" />}
            >
              Буду знать
            </PromoModalAction>
          </PromoModalActions>
        </PromoModalFooter>
      </PromoModalContent>
    </PromoModalRoot>
  );
};
